import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel } from 'rsuite'
import BudgetForm from '../../../components/forms/budgetForm/BudgetForm'
import BudgetTableView from '../../../components/forms/budgetForm/BudgetTableView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import {
  getActivityCost,
  saveActivityCost,
  updateActivityCost,
  deleteActivityCost,
  saveProjectBudget,
  updateProjectBudget,
} from '../../../redux/actions/budget'
import { getProjectBudget } from '../../../redux/actions/budget'
import { startLoading, doneLoading } from '../../../utils/loading'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import { ADD_EDIT, ERR_MSG, RETRY_CONTACT_ADMIN, VIEW_LIST } from '../../../constants/msgText'

export default function ActivityCostWidget({ projectVersionId, ...props }) {
  const {
    showCommandButton,
    isEditAll,
    bordered,
    shaded,
    expanded,
    activityId,
    forceEdit,
    activityOption,
    getSummary,
    getActivity,
  } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, setError } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = projectVersionId || sessionStorage.getItem('projectId')
  const [panelExpanded, setPanelExpanded] = useState(props.schema.values.length > 0 ? true : false)
  const [delErrorMsg, setDelErrorMsg] = useState()
  const [errorMsg, setErrorMsg] = useState()
  // useEffect(() => {
  //   setPanelExpanded(expanded)
  // }, [expanded])

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  useEffect(async () => {
    if (activityOption) {
      const res = await handleCallSchema()
      setFormSchema(res)
    }
  }, [activityOption])

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    setErrorMsg('')
    try {
      let response
      if (request.id) {
        //console.log('call update.')
        response = await updateProjectBudget(projectId, request)
      } else {
        //console.log('call save.')
        response = await saveProjectBudget(projectId, request)
      }

      if (response) {
        const res = await handleCallSchema()
        getSummary()
        getActivity()
        setFormSchema(res)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)

        setErrorMsg('')
      }
    } catch (e) {
      //console.log('e', e)
      setErrorMsg(e?.response?.data?.errorMessage)

      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallSchema = async () => {
    try {
      const _schema = await getProjectBudget(projectId)

      return _schema.forms.managementFee[0]?.subForms[0]
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    setDelErrorMsg('')
    try {
      const status = await deleteActivityCost(projectId, activityId, id)
      if (status === 200) {
        console.log('call get.')
        const res = await handleCallSchema()
        getSummary()
        getActivity()

        setFormSchema(res)

        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsDeleteError(true)
        setDelErrorMsg(`${ERR_MSG}ลบไม่สำเร็จ ${RETRY_CONTACT_ADMIN}`)
      }
    } catch (e) {
      // console.log('e', e)
      setIsDeleteError(true)
      let data = e?.response?.data
      if (data?.status == 500) {
        console.log('data?.errorMessage', data?.errorMessage)
        setDelErrorMsg(data?.errorMessage || `${ERR_MSG} ${RETRY_CONTACT_ADMIN}`)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      id: data.selectedId,
      categoryId: formSchema.categoryId,
      categoryType: formSchema.categoryType,
      // acCostOption: data.acCostOption,
      ActivityId: data.activityOption || '',
      costName: data.costName || data.acCostOption,
      costDetail: data.costDetail || '',
      costPerUnit: data.costPerUnit || 0,
      quantity: data.quantity || 0,
      unitOfMeasure: data.unitOfMeasure || '',
      sumPrice: (parseFloat(data.quantity) * parseFloat(data.costPerUnit)).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      }),
    }

    // console.log('request', request)
    handleUpdateSave(request)
  }

  // const onDelete = (index) => {
  //   console.log
  //   let dataList = [...formSchema.values]
  //   handleDelete(dataList[index])
  // }

  const onDelete = (id) => {
    // console.log('delete id ', id)
    // let dataList = [...formSchema.values]
    handleDelete(id)
  }

  const onEdit = (id) => {
    // console.log('onEdit id ', id)
    // let dataList = [...formSchema.values]
    handleDelete(id)
  }

  const onBackToView = () => {
    // console.log('onBackToView', formSchema.values)

    setFormSchema((state) => ({
      ...state,
    }))
    setIsError(false)
    setIsDeleteError(false)
    setIsEdit(!isEdit)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <Panel
      shaded={shaded}
      bordered={bordered}
      header={formSchema.header}
      // header={
      //   <div
      //     onClick={(e) => {
      //       setPanelExpanded(!panelExpanded)
      //     }}
      //   >
      //     {formSchema.header}
      //   </div>
      // }
      collapsible
      defaultExpanded={panelExpanded}
      ref={(section) => {
        setSection(section)
      }}
      // onClick={(e) => {
      //   if (e.target.className === 'rs-panel-heading' || e.target.className === 'collapsed') {
      //     setPanelExpanded(!panelExpanded)
      //   }
      // }}
      style={{ marginBottom: 20 }}
      // expanded={panelExpanded}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <BudgetForm
          hideHeader={true}
          schema={formSchema}
          activityOptions={activityOption}
          formKey={'ActivityCost'}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setError={setError}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          onEdit={onEdit}
          isError={isError}
          errorMsg={errorMsg}
          isDeleteError={isDeleteError}
          setIsDeleteError={setIsDeleteError}
          delErrorMsg={delErrorMsg}
          loading={isLoading}
          projectVersionId={projectVersionId}
        />
      ) : (
        <>
          <BudgetTableView schema={formSchema} />
        </>
      )}

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                onClick={onBackToView}
              >
                {`${VIEW_LIST} ${formSchema.buttonText ? formSchema.buttonText : ''}`}
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                setIsEdit(!isEdit)
                setIsDeleteError(false)
                setIsError(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
            >
              {`${ADD_EDIT} ${formSchema.buttonText ? formSchema.buttonText : ''}`}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
